(window as any).globals = {
  windowRatio: undefined,
  canvasRatio: undefined,
  toolBarHeight: 27,
  canvasScale: undefined as number | undefined,
}

